import React from 'react'
import { Box, Typography, useTheme } from '@mui/material'
import { useFieldArray, useFormContext, Controller } from 'react-hook-form'
import { ApiAutoComplete } from '../../../../../components/FormElements/ApiAutoComplete'
import GenericButton from '../../../../../components/GenericButton'
import { ButtonType, ButtonSize } from '../../../../../components/GenericButton/styles'
import { ReactComponent as Trash } from '../../../../../assets/trash.svg'
import { black, red, shade } from '../../../../../colors'
import CustomTooltip from '../../../../../components/CustomTooltip'
import GenericAutocomplete from '../../../../../components/FormElements/FormAutoComplete'

interface SlicesSectionProps {
  name: string
  control: any
}

const SlicesSection: React.FC<SlicesSectionProps> = ({ name, control }) => {
  const theme = useTheme()
  const { fields, append, remove } = useFieldArray({
    control,
    name
  })

  const isRemoveDisabled = fields.length === 1

  return (
    <>
      <Typography color={black[100]} fontWeight={700}>Slice Data</Typography>
      <Box padding={theme.spacing(3, 0)} borderRadius={theme.spacing(2)}>
        {fields.map((field, index) => (
          <CustomTooltip key={field.id} title={'This feature will be available in a future update.'} >

            <Box key={field.id} display="flex" flexDirection="column" gap={2} width="100%">
              {/*  This is a placeholder for the slice selection, as the feature is not yet implemented */}
             <GenericAutocomplete
                name={'slices'}
                control={control}
                label={'Slice By'}
                placeholder={'Select a slice'}
                getOptionLabel={(option) => option.title}
                getOptionValue={(option) => option.value}
                options={[{ title: 'test', value: 'test ' }, { title: 'test 2', value: 'test 2' }]}
                readOnly
              />
              <Box display="flex" justifyContent="flex-end" width="100%">
                <GenericButton
                  buttonType={ButtonType.Ghost}
                  buttonSize={ButtonSize.Small}
                  startIcon={<Trash style={{ opacity: isRemoveDisabled ? 0.5 : 1 }} />}
                  label={'Remove Slice'}
                  onClick={() => { remove(index) }}
                  disabled={isRemoveDisabled}
                  style={{
                    background: 'transparent'
                  }}

                />
              </Box>
            </Box>
          </CustomTooltip>
        ))}
      </Box>
      <Box display="flex" justifyContent="flex-end" alignItems="center">
        <GenericButton
          disabled={true}
          buttonType={ButtonType.Ghost}
          buttonSize={ButtonSize.Small}
          label={'+ Add Slice'}
          style={{ fontWeight: 600, fontSize: '16px', cursor: 'pointer' }}
          onClick={() => { append({ sliceBy: '' }) }}
        />
      </Box>
    </>
  )
}

export default SlicesSection
